import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { keys, values } from "ramda";
import { ExpertModeTheme } from "../../theme/expert-mode";

const Root = styled.table<{ expertTheme: ExpertModeTheme }>(
    props => css`
        width: 100%;
        border: 1px solid ${props.expertTheme.colors.subtle};
        border-radius: 8px;
        table-layout: fixed;
    `)

const TableHead = styled.thead(css``)

const TableBody = styled.tbody(css``)

const Row = styled.tr(css``)

const HeaderRow = styled.tr<{ expertTheme: ExpertModeTheme }>(
    props => css`
        color: ${props.expertTheme.colors.textLight};
        background-color: ${props.expertTheme.colors.superSubtle};
    `)

const HeaderCell = styled.th<{ expertTheme: ExpertModeTheme }>(
    props => css`
        text-align: left;
        padding: 5px;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        border-bottom: 1px solid ${props.expertTheme.colors.subtle};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    `)

const Cell = styled.td(
    css`
        padding: 5px;
    `)

type Props<Keys extends string = string> = {
    data: Array<{ [K in Keys]: string }>,
    headerLabels: { [K in Keys]: string };
    expertTheme: ExpertModeTheme
}

const Table = <Keys extends string>({ headerLabels, expertTheme, data }: Props<Keys>) => (
    <Root {...{ expertTheme }}>
        <TableHead>
            <HeaderRow {...{ expertTheme }}>
                {values(headerLabels).map(header =>
                    <HeaderCell {...{ expertTheme }}>{header}</HeaderCell>
                )}
            </HeaderRow>
        </TableHead>
        <TableBody>
            {data.map(entry =>
                <Row>
                    {keys(headerLabels).map(k => <Cell>{entry[k]}</Cell>)}
                </Row>
            )}
        </TableBody>
    </Root>
)

export default Table